var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 58,
    viewBox: "0 0 54 58",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5973 26.4072V16.0098C13.594 12.7868 14.8115 9.67746 17.0133 7.28555C19.2152 4.89363 22.2443 3.38974 25.5127 3.06583C28.7811 2.74192 32.0556 3.62109 34.7005 5.53267C37.34 7.48113 40.0907 10.8114 40.0907 16.0098C40.0907 21.2083 40.0907 25.1078 40.0907 26.4074M8.29867 26.4072H45.3893C48.3157 26.4072 50.688 28.7347 50.688 31.6059V49.8013C50.688 52.6725 48.3157 55 45.3893 55H8.29867C5.37229 55 3 52.6725 3 49.8013V31.6059C3 28.7347 5.37229 26.4072 8.29867 26.4072Z",
    stroke: "currentColor",
    strokeWidth: 5.29867,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.3a950758daea94948e760fa42c8b9ba0.svg";
export { ForwardRef as ReactComponent };